import { all, fork } from "redux-saga/effects";

//public
import AccountSaga from "./auth/register/saga";
import AuthSaga from "./auth/login/saga";
import ForgetSaga from "./auth/forgetpwd/saga";
import ProfileSaga from "./auth/profile/saga";
import LayoutSaga from "./layout/saga";
import calendarSaga from "./calendar/saga";
import chatSaga from "./chat/saga";
import cryptoSaga from "./crypto/saga";
import projectsSaga from "./projects/saga";
import tasksSaga from "./tasks/saga";
import mailsSaga from "./mails/saga";
import contactsSaga from "./contacts/saga";
import dashboardSaga from "./dashboard/saga";
import dashboardSaasSaga from "./dashboard-saas/saga";
import roleSaga from "./role/saga";
import unitSaga from "./unit/saga";
import warehouseSaga from "./warehouse/saga";
import categorySaga from "./category/saga";
import attributeSaga from "./attribute/saga";
import userSaga from "./user/saga";
import currencySaga from "./currency/saga";
import bannerSaga from "./banner/saga";
import itemShippingFeeSaga from "./item-shipping-fee/saga";
import itemShippingFeeEntrySaga from "./item-shipping-fee-entry/saga";
import userItemShippingFeeSaga from "./user-item-shipping-fee/saga";
import shippingAddressSaga from "./shipping-contact/saga";
import permissionSaga from "./permission/saga";
import invoiceSaga from "./invoice/saga";
import invoicePaymentSaga from "./invoice-payment/saga";
import invoiceNoteSaga from "./invoice-note/saga";
import invoicePaymentHistorySaga from "./invoice-payment-history/saga";
import invoiceReportSaga from "./invoice-report/saga";
import settingSaga from "./settings/saga";
import supplierSaga from "./supplier/saga";
import companySaga from "./company/saga";
import storeSaga from "./store/saga";
import productSaga from "./product/saga";
import productImageSaga from "./product-image/saga";
import OrderSaga from "./sale-order/saga";
import itemSaga from "./item/saga";
import itemAttachmentSaga from "./item-attachment/saga";
import unitOfMeasurementSaga from "./unit-of-measurement/saga";
import itemUnitOfMeasurementSaga from "./item-unit-of-measurement/saga";
import stockInSaga from "./stock-in/saga";
import stockInItemSaga from "./stock-in-item/saga";
import stockAdjustmentSaga from "./stock-adjustment/saga";
import stockAdjustmentItemSaga from "./stock-adjustment-item/saga";
import purchaseOrderItemSaga from "./purchase-order-item/saga";
import stockOutSaga from "./stock-out/saga";
import stockOutItemSaga from "./stock-out-item/saga";
import productStockInSaga from "./product-stock-in/saga";
import productStockInProductSaga from "./product-stock-in-product/saga";
import productUnitOfMeasurementSaga from "./product-unit-of-measurement/saga";
import productStockOutSaga from "./product-stock-out/saga";
import productStockOutProductSaga from "./product-stock-out-product/saga";
import clothingSizeSaga from "./clothing-size/saga";
import stockRequestSaga from "./stock-request/saga";
import stockRequestItemSaga from "./stock-request-item/saga";
import purchaseOrderAttachmentSaga from "./purchase-order-attachment/saga";
import itemUsageLimitationSaga from "./item-usage-limitation/saga";
import stockLocationSaga from "./stock-location/saga";
import transferLocationSaga from "./transfer-location/saga";
import codeColorSaga from "./code-color/saga";
import locationSaga from "./location/saga";

export default function* rootSaga() {
  yield all([
    fork(AccountSaga),
    fork(AuthSaga),
    fork(ForgetSaga),
    fork(ProfileSaga),
    fork(LayoutSaga),
    fork(calendarSaga),
    fork(chatSaga),
    fork(mailsSaga),
    fork(cryptoSaga),
    fork(projectsSaga),
    fork(tasksSaga),
    fork(contactsSaga),
    fork(dashboardSaga),
    fork(dashboardSaasSaga),
    fork(roleSaga),
    fork(unitSaga),
    fork(warehouseSaga),
    fork(categorySaga),
    fork(attributeSaga),
    fork(userSaga),
    fork(currencySaga),
    fork(bannerSaga),
    fork(itemShippingFeeSaga),
    fork(itemShippingFeeEntrySaga),
    fork(userItemShippingFeeSaga),
    fork(shippingAddressSaga),
    fork(permissionSaga),
    fork(invoiceSaga),
    fork(invoiceNoteSaga),
    fork(invoicePaymentSaga),
    fork(invoicePaymentHistorySaga),
    fork(invoiceReportSaga),
    fork(settingSaga),
    fork(supplierSaga),
    fork(companySaga),
    fork(storeSaga),
    fork(productSaga),
    fork(productImageSaga),
    fork(OrderSaga),
    fork(itemSaga),
    fork(itemAttachmentSaga),
    fork(unitOfMeasurementSaga),
    fork(itemUnitOfMeasurementSaga),
    fork(stockInSaga),
    fork(stockInItemSaga),
    fork(stockAdjustmentSaga),
    fork(stockAdjustmentItemSaga),
    fork(purchaseOrderItemSaga),
    fork(stockOutSaga),
    fork(stockOutItemSaga),
    fork(productStockInSaga),
    fork(productStockInProductSaga),
    fork(productUnitOfMeasurementSaga),
    fork(productStockOutSaga),
    fork(productStockOutProductSaga),
    fork(clothingSizeSaga),
    fork(stockRequestSaga),
    fork(stockRequestItemSaga),
    fork(purchaseOrderAttachmentSaga),
    fork(itemUsageLimitationSaga),
    fork(stockLocationSaga),
    fork(transferLocationSaga),
    fork(codeColorSaga),
    fork(locationSaga),
  ]);
}
